// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"1704d99e","61":"c0f0b3ed","367":"c0ee3b8c","500":"bb5a14cf","523":"7f777726","542":"fdf2eba2","579":"04091aa0","634":"f50734e4","667":"6def65fc","784":"563a480d","901":"e109f2fa","921":"891fefd2"}[chunkId] + ".css";
};